import { ReactElement } from 'react';

import { AuthProvider } from '../contexts/AuthContext';
import Cadastro from './ClubeBeneficios/Cadastro';

export function ClubeBeneficiosPage(): ReactElement {
  return (
    <>
      <div className="h-full">
        <AuthProvider>
          <Cadastro />
        </AuthProvider>
      </div>
    </>
  );
}
